import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { faArchive, faWarning, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useArchiveDevice from '../../useArchiveDevice';
import ModalComponent from '../../../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../../../contexts/ModalContext/ModalContext';

/* istanbul ignore next */
function ArchiveDeviceModal({ deviceId, deviceName, setModalJSX }) {
  const [show, setShow] = useState(true);
  const { archiveDevice, submitting, submitted } = useArchiveDevice();

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  useEffect(() => {
    if (submitted) {
      closeModalHandler();
    }
  }, [submitted]);

  return (
    <ModalComponent
      show={show}
      close={closeModalHandler}
      showConfirmCallToAction
      // setting submit btn text to empty str, to let ProgressSpinnerr render text
      confirmButtonText={submitting ? '' : 'Archive This Device'}
      actionBtnIcon={submitting ? (
        <ProgressSpinner useSmallSpinner progressText="Archiving" />
      ) : null}
      isBtnDisabled={submitting}
      confirmButtonAction={() => archiveDevice(deviceId)}
    >
      <Modal.Header>
        <div className="mx-auto text-center">
          <h3>
            <FontAwesomeIcon icon={faArchive} className="text-muted" />
            {' '}
            Archive Device
          </h3>
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          <div className="alert alert-warning">
            <FontAwesomeIcon icon={faWarning} />
            {' '}
            You are about to archive device
            {' '}
            <b>{deviceName}</b>
            .
          </div>
          <p>
            This device will be available in your
            {' '}
            <i>Archived</i>
            {' '}
            list
            for historical reference.
            Alerts for this device will be deleted. This action cannot
            be undone.
          </p>
          <p className="small">
            You can completely remove the device from your account by
            first archiving it,
            then deleting it from the
            {' '}
            <i>Archived</i>
            {' '}
            device list.
          </p>
          <br />
          <div className="alert alert-info">
            <p><b>Is your Room Alert Monitor offline?</b></p>
            <p>
              If your Room Alert Monitor appears as
              {' '}
              <b>Offline</b>
              {' '}
              or
              {' '}
              <b>Not Connected</b>
              {' '}
              in your Room Alert Account, follow these
              {' '}
              <a
                href="js/src/components/devices/ArchiveDeviceButton/ArchiveDeviceModal/ArchiveDeviceModal"
                target="_blank"
                rel="noopener noreferrer"
              >
                troubleshooting steps
              </a>
              .
              Removing the device and re-registering it will
              {' '}
              <b>not</b>
              {' '}
              resolve the issue.
              {' '}
              <a
                href="https://avtech.com/support"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact our Technical Support Team
              </a>
              {' '}
              for further assistance.
              {' '}
              <a
                href="js/src/components/devices/ArchiveDeviceButton/ArchiveDeviceModal/ArchiveDeviceModal"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInfoCircle} />
              </a>
            </p>
          </div>
        </>
      </Modal.Body>
    </ModalComponent>
  );
}

ArchiveDeviceModal.propTypes = {
  // hasAdvancedRoles: PropTypes.bool.isRequired,
  deviceId: PropTypes.number.isRequired,
  deviceName: PropTypes.string.isRequired,
  setModalJSX: PropTypes.func.isRequired,
};

export default connectModalContainerContextToComponent(ArchiveDeviceModal);
